import React, { useState, useEffect } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { useNavigate } from 'react-router-dom';


//Rotas
import routes from '../../../routes/views.routes';

//Context
import { useAuth } from '../../../context/auth';

//API
import usuario_api from '../../../api/usuario_api';

//Helpers
import { showMessage } from '../../../helpers/message';

function Relatorios() {
  const { setLoading } = useAuth();

  //State para pegar lista de rotas de relatório 
  const [listRelatorios, setListRelatorios] = useState([]);

  const navigate = useNavigate();

  async function GetFuncionalidadesRelatorios() {
    setLoading(true);
    try {
      // Rotas que são relatórios
      let routesRelatorios = routes.filter(x => x.relatorio === true);

      const { data } = await usuario_api.GetFuncionalidades();

      if (data && data.length > 0) {
        const rotasPermitidas = routesRelatorios.filter(route =>
          data.some(f => f.codigoFuncionalidade === route.codigoFuncionalidade)
        );
        setListRelatorios(rotasPermitidas);
      } else
        setListRelatorios([]);
    } catch (error) {
      showMessage(
        "Error",
        error?.message ?? "Erro na operação!",
        "error",
        null
      );
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (routes.filter(x => x.relatorio == true).length > 0)
      GetFuncionalidadesRelatorios();
  }, []);

  return <>
    <h4 className='text-secondary m-0'>Relatórios</h4>
    <Row className='mt-3'>

      {listRelatorios.map((relatorio, index) => (
        <Col key={index} className='p-2' sm="12" md="6" lg="4">
          <div className='bg-light mt-2 rounded-3 w-100 h-100 shadow d-flex align-items-start justify-content-between flex-column'>
            <h5 className='ps-3 pt-3 pb-2'>{relatorio.name}</h5>
            <div className='w-100 d-flex align-items-center justify-content-end pe-3 pt-3 pb-3'>
              <Button color='primary text-light' style={{ fontWeight: "600" }} onClick={() => navigate(`${relatorio.layout}/${relatorio.path}`)}>Gerar </Button>
            </div>
          </div>
        </Col>
      ))
      }
    </Row>
  </>;
}

export default Relatorios;